import type { QuestionBooleanModelData } from '@coorum-research/shared-common/types'
import type { SurveyElementForm } from './survey-element-form'
import { motion } from 'motion/react'
import { useState } from 'react'
import { cn } from '../../utils'
import { ElementCommentField } from './ElementCommentField'
import { ElementHeader } from './ElementHeader'
import { ElementValidationMessage } from './ElementValidationMessage'
import { SurveyElementLayout } from './SurveyElementLayout'

type Prop = {
  currentForm: SurveyElementForm
  validationError: string | null
  onValidationError: (errorMessage: string) => void
  onClickNext?: () => void
}

export function SurveyElementBoolean({
  currentForm,
  validationError,
  onValidationError,
  onClickNext,
}: Prop) {
  const currentElement = currentForm.elementJson as QuestionBooleanModelData
  const selectOptions = currentForm.getSelectOptions()
  const [value, setValue] = useState(() => String(currentForm.getSelectOptionValue()))

  return (
    <SurveyElementLayout>
      <ElementValidationMessage
        validationError={validationError}
      />
      <ElementHeader
        currentElement={currentElement}
      />

      <div className="w-fit overflow-hidden rounded-full border border-[#909190] bg-white font-survey">
        <div className="relative m-0.5 flex w-fit gap-2 rounded-lg bg-white p-0.5">
          {selectOptions.map(option => (
            <button
              type="button"
              key={String(option.value)}
              onClick={() => {
                setValue(String(option.value))
                currentForm.setElementResultRecordValue(option.value)
                onValidationError('')
                if (!currentElement.showCommentArea) {
                  onClickNext?.()
                }
              }}
              className={cn(
                'relative px-6 py-2 text-base rounded-full transition-colors duration-200 z-10 hover:bg-input',
                value === option.value ? 'text-[var(--theme-text-color)] font-bold' : 'text-gray-500 font-medium',
              )}
            >
              {value === String(option.value) && (
                <motion.div
                  layoutId="activeTabBackground"
                  className="absolute inset-0 rounded-full bg-[var(--theme-bg-color)] shadow-sm"
                  transition={{
                    type: 'spring',
                    stiffness: 300,
                    damping: 30,
                  }}
                />
              )}
              <span className="relative z-10">{option.label}</span>
            </button>
          ))}
        </div>
      </div>
      {currentElement.showCommentArea && (
        <ElementCommentField
          label={currentElement.commentText}
          placeholder={currentElement.commentPlaceholder}
          defaultValue={currentForm.getComment()}
          onChange={(e) => {
            currentForm.setElementResultRecordComment(e.target.value || '')
          }}
        />
      )}
    </SurveyElementLayout>
  )
}
